import styled from '@emotion/styled';
import { MouseEvent, useRef } from 'react';

import { Criteria } from '../../models/Criteria';
import { AnswerButton } from '../styledComponent/Buttons.style';
import { getColor } from './UICommon';

const P = styled.p`
  font-weight: 500;
  &.title {
    font-weight: 600;
    margin-bottom: 3px;
  }
  &.description {
    color: ${getColor('BLACK_60')};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }
`;

const Img = styled.img`
  width: 24px;
`;

interface AnswersFunnelButtonProps {
  criteria: Criteria;
  onClick: (criteria: Criteria) => void;
  isActive: boolean;
}

export const AnswersFunnelButton = ({ criteria, isActive, onClick }: AnswersFunnelButtonProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    if (buttonRef.current) {
      buttonRef.current.focus();
    }
    onClick(criteria);
  };

  return (
    <AnswerButton
      id={criteria.id}
      onClick={handleClick}
      className={isActive ? 'active' : ''}
      onTouchStart={() => handleClick}
      ref={buttonRef}
    >
      {criteria.meta?.iconUrl && <Img src={criteria.meta?.iconUrl} />}
      <P>{criteria.label}</P>
    </AnswerButton>
  );
};
